export default {
  createSubscriber: {
    loading: false,
    error: null,
    data: [],
  },
};
